import React from 'react';
import { PortfolioDetailsReportItem } from '../../../../models/Portfolio';
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReplyIcon from '@mui/icons-material/Reply';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import { LeoDocumentsPath, LeoDocumentsPathExample } from '../../../../resources/api-constants';

export interface ITableReportsProps {
    reports: PortfolioDetailsReportItem[];
}

const TableReports: React.FC<ITableReportsProps> = ({ reports }) => {
    const { t, i18n } = useTranslation();

    const onDownload = () => {
        window.open(LeoDocumentsPath + '/' + LeoDocumentsPathExample);
    }
    
    return <Table sx={{ width: "100%" }} aria-label="simple table">
        <TableHead>
            <TableRow>
                <TableCell>#</TableCell>
                <TableCell>{t('PortfolioDetailsReportsPortfolioDataRoomDocumentName')}</TableCell>
                <TableCell>{t('PortfolioDetailsReportsPortfolioDataRoomDate')}</TableCell>
                <TableCell>{t('PortfolioDetailsReportsPortfolioDataRoomAction')}</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {reports.map((r, i) => <TableRow key={r.id}>
                <TableCell>{i + 1}.</TableCell>
                <TableCell sx={{ textDecoration: "underline"}}>{r.name}</TableCell>
                <TableCell>{r.date.toLocaleDateString(i18n.language)}</TableCell>
                <TableCell sx={{ display: "flex", gap: "5px", alignContent: "center"}}>
                    <IconButton size={"small"} onClick={onDownload} aria-label={t('A11yShareDocument')}><ReplyIcon fontSize="small" /></IconButton>
                    <IconButton size={"small"} onClick={onDownload} aria-label={t('A11yDownloadDocument')}><VerticalAlignBottomIcon fontSize="small" /></IconButton>
                </TableCell>
            </TableRow>)}
        </TableBody>
    </Table>
}

export default TableReports;